import {formatDateCommon} from "@/libs/helper";

export const PaymentReminder: React.FC<any> = ({data}) => {
  return (
    <>
      <div className="w-[100%] rounded-xl bg-white p-6 shadow-lg">
        <svg
          width="100%"
          height="142"
          viewBox="0 0 413 142"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M244.559 130.983C276.542 130.983 302.469 105.056 302.469 73.0729C302.469 41.0902 276.542 15.1631 244.559 15.1631C212.577 15.1631 186.649 41.0902 186.649 73.0729C186.649 105.056 212.577 130.983 244.559 130.983Z"
            fill="#FFEE99"
          />
          <path
            d="M302.427 8.37911L300.681 6.54079C297.759 3.46503 292.154 4.04526 288.162 7.83644C284.17 11.6276 283.302 17.197 286.224 20.2728L287.97 22.1111C290.892 25.1868 296.497 24.6066 300.489 20.8154C304.481 17.0243 305.349 11.4549 302.427 8.37911Z"
            fill="#F7DE51"
          />
          <path
            d="M296.706 16.8319C299.738 13.9513 300.397 9.7224 298.178 7.38632C295.959 5.05023 291.702 5.49164 288.669 8.37223C285.637 11.2528 284.978 15.4818 287.197 17.8178C289.416 20.1539 293.673 19.7125 296.706 16.8319Z"
            fill="#333333"
          />
          <path
            d="M296.711 16.8383C298.328 15.3041 299.261 13.387 299.453 11.5768C299.428 10.2924 299.004 9.10194 298.146 8.19686C295.926 5.86094 291.67 6.30033 288.637 9.1808C287.02 10.7149 286.087 12.6321 285.896 14.4423C285.92 15.7266 286.344 16.9171 287.202 17.8222C289.422 20.1581 293.679 19.7187 296.711 16.8383Z"
            fill="#B6C7DD"
          />
          <path
            d="M301.669 7.58061L299.923 5.7423C297.001 2.66654 291.396 3.24677 287.404 7.03794C283.412 10.8291 282.544 16.3985 285.466 19.4743L287.212 21.3126C290.134 24.3884 295.739 23.8081 299.731 20.017C303.724 16.2258 304.591 10.6564 301.669 7.58061Z"
            stroke="#333333"
            stroke-width="0.663949"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M297.978 18.1712C301.97 14.3792 302.837 8.8117 299.915 5.73577C296.993 2.65984 291.388 3.24031 287.397 7.03228C283.405 10.8243 282.538 16.3918 285.46 19.4677C288.382 22.5437 293.986 21.9632 297.978 18.1712Z"
            stroke="#333333"
            stroke-width="0.663949"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M272.764 37.7486H269.869V27.3496C269.869 26.0747 268.827 25.0325 267.552 25.0325H247.916V29.2706H264.42C265.124 29.2706 265.7 29.8471 265.7 30.5512V37.7467H262.797C262.373 37.7467 262.136 38.2368 262.401 38.5673L267.386 44.8428C267.589 45.0981 267.976 45.0981 268.179 44.8428L273.164 38.5673C273.427 38.235 273.192 37.7467 272.768 37.7467L272.764 37.7486Z"
            fill="#F7DE51"
          />
          <path
            d="M216.298 108.405H219.194V118.804C219.194 120.079 220.236 121.121 221.511 121.121H241.147V116.883H224.643C223.939 116.883 223.362 116.306 223.362 115.602V108.407H226.265C226.69 108.407 226.926 107.917 226.662 107.586L221.676 101.311C221.473 101.055 221.087 101.055 220.884 101.311L215.898 107.586C215.636 107.919 215.872 108.407 216.295 108.407L216.298 108.405Z"
            fill="#F7DE51"
          />
          <path
            d="M260 75.5966L260 35.4034C260 32.9715 258.37 31 256.359 31L187.641 31C185.63 31 184 32.9715 184 35.4034L184 75.5966C184 78.0285 185.63 80 187.641 80L256.359 80C258.37 80 260 78.0285 260 75.5966Z"
            fill="#F7DE51"
          />
          <path
            d="M260 75.5965L260 35.4034C260 32.9715 258.37 31 256.359 31L187.641 31C185.63 31 184 32.9715 184 35.4034L184 75.5965C184 78.0285 185.63 80 187.641 80L256.359 80C258.37 80 260 78.0285 260 75.5965Z"
            stroke="#333333"
            stroke-width="0.865753"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M258 73.8468L258 61.4706C258 59.0921 258 59.1826 258 55.6402C258 52.0979 258 51.9102 258 49.5317L258 37.1555C258 34.8695 256.493 33 254.65 33L189.35 33C187.507 33 186 34.8695 186 37.1555L186 73.8445C186 76.1305 187.507 78 189.35 78L254.65 78C256.493 78 258 76.1305 258 73.8445L258 73.8468Z"
            fill="#EFEFEF"
          />
          <path
            d="M255.938 39L236 39"
            stroke="#333333"
            stroke-width="0.865753"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M211.936 70L192 70"
            stroke="#333333"
            stroke-width="0.865753"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M232.237 65.2373C237.804 59.6708 237.804 50.6456 232.237 45.0791C226.671 39.5126 217.646 39.5126 212.079 45.0791C206.513 50.6456 206.513 59.6708 212.079 65.2373C217.646 70.8038 226.671 70.8038 232.237 65.2373Z"
            fill="#F7DE51"
          />
          <path d="M216 31H228.5L228 33H217L216 31Z" fill="#333333" />
          <path
            d="M222.5 32.5C222.225 32.5 222 32.2746 222 32C222 31.7254 222.225 31.5 222.5 31.5C222.775 31.5 223 31.7254 223 32C223 32.2746 222.775 32.5 222.5 32.5Z"
            fill="#7E7E7E"
          />
          <path
            d="M305.999 109.597L305.999 69.4034C305.999 66.9715 304.369 65 302.358 65L233.64 65C231.629 65 229.999 66.9715 229.999 69.4034L229.999 109.597C229.999 112.029 231.629 114 233.64 114L302.358 114C304.369 114 305.999 112.029 305.999 109.597Z"
            fill="#F7DE51"
          />
          <path
            d="M305.999 109.597L305.999 69.4034C305.999 66.9715 304.369 65 302.358 65L233.64 65C231.629 65 229.999 66.9715 229.999 69.4034L229.999 109.597C229.999 112.029 231.629 114 233.64 114L302.358 114C304.369 114 305.999 112.029 305.999 109.597Z"
            stroke="#333333"
            stroke-width="0.865753"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M303.999 107.847L303.999 95.4706C303.999 93.0921 303.999 93.1826 303.999 89.6402C303.999 86.0979 303.999 85.9102 303.999 83.5317L303.999 71.1555C303.999 68.8695 302.492 67 300.649 67L235.349 67C233.506 67 231.999 68.8695 231.999 71.1555L231.999 107.845C231.999 110.131 233.506 112 235.349 112L300.649 112C302.492 112 303.999 110.131 303.999 107.845L303.999 107.847Z"
            fill="#EFEFEF"
          />
          <path
            d="M301.937 73L281.999 73"
            stroke="#333333"
            stroke-width="0.865753"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M257.935 104L237.999 104"
            stroke="#333333"
            stroke-width="0.865753"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M278.236 99.2373C283.803 93.6708 283.803 84.6456 278.236 79.0791C272.67 73.5126 263.645 73.5126 258.078 79.0791C252.512 84.6456 252.512 93.6708 258.078 99.2373C263.645 104.804 272.67 104.804 278.236 99.2373Z"
            fill="#F7DE51"
          />
          <path
            d="M164.349 60.2555L166.58 59.05C170.313 57.0333 175.46 59.3261 178.077 64.1706C180.695 69.0152 179.79 74.5771 176.057 76.5938L173.826 77.7994C170.093 79.8161 164.946 77.5233 162.329 72.6787C159.711 67.8341 160.616 62.2722 164.349 60.2555Z"
            fill="#F7DE51"
          />
          <path
            d="M175.89 73.9596C178.725 72.4281 179.411 68.2035 177.423 64.5237C175.435 60.844 171.525 59.1025 168.691 60.634C165.856 62.1656 165.169 66.3901 167.157 70.0699C169.145 73.7497 173.055 75.4912 175.89 73.9596Z"
            fill="#333333"
          />
          <path
            d="M167.154 70.0729C166.095 68.1125 165.802 66 166.183 64.2199C166.606 63.0069 167.377 62.006 168.476 61.4127C171.311 59.8804 175.221 61.623 177.209 65.3015C178.268 67.2619 178.561 69.3743 178.18 71.1544C177.758 72.3675 176.986 73.3683 175.887 73.9617C173.052 75.4939 169.142 73.7514 167.154 70.0729Z"
            fill="#B6C7DD"
          />
          <path
            d="M165.318 59.7321L167.549 58.5266C171.282 56.5099 176.428 58.8026 179.046 63.6472C181.664 68.4918 180.759 74.0537 177.026 76.0704L174.795 77.2759C171.062 79.2926 165.915 76.9999 163.297 72.1553C160.68 67.3107 161.585 61.7488 165.318 59.7321Z"
            stroke="#333333"
            stroke-width="0.663949"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M177.028 76.0679C180.761 74.0513 181.666 68.4898 179.049 63.6457C176.432 58.8017 171.284 56.5097 167.552 58.5262C163.819 60.5428 162.914 66.1044 165.531 70.9484C168.148 75.7924 173.296 78.0845 177.028 76.0679Z"
            stroke="#333333"
            stroke-width="0.663949"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M274.465 91.9751C273.466 90.9761 272.935 90.3621 272.935 88.8712V88.4806C272.935 86.6573 271.825 85.0912 270.246 84.4228C270.289 84.2707 270.319 84.1129 270.319 83.9458C270.319 82.9581 269.519 82.1582 268.531 82.1582C267.544 82.1582 266.744 82.9581 266.744 83.9458C266.744 84.1129 266.774 84.2707 266.817 84.4228C265.236 85.0912 264.128 86.6573 264.128 88.4806V88.8712C264.128 90.3621 263.597 90.9761 262.598 91.9751C262.179 92.3938 262.034 93.0247 262.001 93.6782C261.989 93.896 262.166 94.08 262.385 94.08H274.681C274.899 94.08 275.077 93.896 275.066 93.6782C275.032 93.0247 274.888 92.3938 274.469 91.9751H274.465ZM267.677 83.9458C267.677 83.4745 268.06 83.0914 268.531 83.0914C269.003 83.0914 269.386 83.4745 269.386 83.9458C269.386 84.0191 269.374 84.0885 269.356 84.1561C269.089 84.1054 268.813 84.0754 268.531 84.0754C268.25 84.0754 267.974 84.1054 267.707 84.1561C267.69 84.0885 267.677 84.0191 267.677 83.9458ZM266.59 94.5589H270.471C270.471 95.6311 269.602 96.5005 268.529 96.5005C267.457 96.5005 266.588 95.6311 266.588 94.5589H266.59Z"
            fill="#333333"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M215.102 50.6109C215.208 50.3922 215.47 50.156 215.702 50.0713C215.888 50.0031 215.973 50.0022 222.49 50.0004C229.068 49.9987 229.09 49.9989 229.288 50.0696C229.53 50.1559 229.789 50.3856 229.898 50.6109C229.969 50.7582 229.978 50.84 229.988 51.4879L230 52.2024H222.5H215L215.012 51.4879C215.022 50.84 215.031 50.7582 215.102 50.6109ZM215.066 60.2947C215.011 60.1299 215.005 59.8155 215.005 56.7091V53.3042H222.501H229.996L229.987 56.7733L229.977 60.2425L229.881 60.416C229.757 60.639 229.515 60.8511 229.288 60.9344C229.115 60.9981 228.914 61 222.482 61H215.854L215.664 60.918C215.412 60.8096 215.147 60.5332 215.066 60.2947ZM225.961 55.0026C225.941 54.7765 226.054 54.5891 226.275 54.4826C226.436 54.4047 226.446 54.4043 227.74 54.4137L229.043 54.4233L229.18 54.5225C229.351 54.6474 229.43 54.8202 229.407 55.0202C229.386 55.1926 229.301 55.3186 229.128 55.4305C229.01 55.5073 228.998 55.5079 227.683 55.5079C226.368 55.5079 226.356 55.5073 226.238 55.4305C226.059 55.3144 225.977 55.1878 225.961 55.0026ZM218.856 57.762L219.236 59H219.543L219.949 57.7641H219.959L219.953 57.8969C219.95 57.9552 219.947 58.0167 219.945 58.0815C219.944 58.1462 219.943 58.2034 219.943 58.2531V59H220.255V57.422H219.799L219.403 58.6287H219.397L219.023 57.422H218.568V59H218.867V58.266C218.867 58.2121 218.865 58.1516 218.863 58.0847C218.86 58.0178 218.856 57.9548 218.853 57.8958L218.846 57.762H218.856ZM222.04 58.5413C222.07 58.4413 222.086 58.3304 222.086 58.2088C222.086 58.0448 222.059 57.9019 222.005 57.7803C221.951 57.6587 221.869 57.5645 221.758 57.4975C221.648 57.4306 221.508 57.3972 221.336 57.3972C221.164 57.3972 221.023 57.4306 220.911 57.4975C220.8 57.5645 220.717 57.6587 220.663 57.7803C220.61 57.9012 220.583 58.0433 220.583 58.2067C220.583 58.329 220.598 58.4402 220.628 58.5402C220.659 58.6402 220.704 58.7262 220.765 58.7982C220.827 58.8701 220.905 58.9255 221 58.9644C221.094 59.0025 221.205 59.0216 221.334 59.0216C221.463 59.0216 221.575 59.0025 221.669 58.9644C221.763 58.9255 221.841 58.8701 221.902 58.7982C221.964 58.7262 222.01 58.6406 222.04 58.5413ZM220.975 58.4938C220.948 58.4139 220.934 58.3189 220.934 58.2088C220.934 58.098 220.948 58.003 220.975 57.9239C221.003 57.844 221.046 57.7828 221.105 57.7404C221.165 57.6972 221.242 57.6756 221.336 57.6756C221.478 57.6756 221.58 57.7231 221.642 57.8181C221.704 57.9131 221.735 58.0433 221.735 58.2088C221.735 58.3189 221.721 58.4139 221.694 58.4938C221.667 58.5729 221.624 58.6341 221.565 58.6773C221.506 58.7197 221.429 58.741 221.334 58.741C221.241 58.741 221.164 58.7197 221.105 58.6773C221.046 58.6341 221.003 58.5729 220.975 58.4938ZM223.387 59H223.812V57.422H223.511V58.1689L223.516 58.3135L223.522 58.4582C223.524 58.5064 223.526 58.5549 223.528 58.6039H223.52L222.835 57.422H222.413V59H222.712V58.2574L222.705 58.1074L222.699 57.9563C222.696 57.9059 222.694 57.8559 222.691 57.8062H222.701L223.387 59ZM224.211 59H225.12V58.7237H224.545V58.3168H225.08V58.0426H224.545V57.6961H225.12V57.422H224.211V59ZM226.27 57.422L225.941 58.0718L225.614 57.422H225.251L225.775 58.3966V59H226.107V58.3858L226.631 57.422H226.27Z"
            fill="#333333"
          />
          <g clip-path="url(#clip0_3062_9265)">
            <path
              d="M377.147 65.0035C377.147 65.7202 376.56 66.2993 375.834 66.2993C375.107 66.2993 374.524 65.7162 374.524 65.0035C374.524 64.2908 375.111 63.7077 375.838 63.7077C376.564 63.7077 377.151 64.2868 377.151 65.0035H377.147Z"
              fill="#333333"
            />
            <path
              d="M389.028 65.0035C389.028 65.7162 388.441 66.2993 387.715 66.2993C386.988 66.2993 386.401 65.7202 386.401 65.0035C386.401 64.2868 386.988 63.7077 387.715 63.7077C388.441 63.7077 389.028 64.2868 389.028 65.0035Z"
              fill="#333333"
            />
            <path
              d="M400.913 65.0035C400.913 65.7202 400.326 66.2993 399.599 66.2993C398.873 66.2993 398.286 65.7202 398.286 65.0035C398.286 64.2868 398.873 63.7077 399.599 63.7077C400.326 63.7077 400.913 64.2868 400.913 65.0035Z"
              fill="#333333"
            />
            <path
              d="M411.48 66.2993C412.206 66.2993 412.794 65.7191 412.794 65.0035C412.794 64.2879 412.206 63.7077 411.48 63.7077C410.755 63.7077 410.167 64.2879 410.167 65.0035C410.167 65.7191 410.755 66.2993 411.48 66.2993Z"
              fill="#333333"
            />
            <path
              d="M377.147 76.2686C377.147 76.9854 376.56 77.5644 375.834 77.5644C375.107 77.5644 374.524 76.9813 374.524 76.2686C374.524 75.556 375.111 74.9729 375.838 74.9729C376.564 74.9729 377.151 75.5519 377.151 76.2686H377.147Z"
              fill="#333333"
            />
            <path
              d="M389.028 76.2686C389.028 76.9854 388.441 77.5644 387.715 77.5644C386.988 77.5644 386.401 76.9854 386.401 76.2686C386.401 75.5519 386.988 74.9729 387.715 74.9729C388.441 74.9729 389.028 75.5519 389.028 76.2686Z"
              fill="#333333"
            />
            <path
              d="M399.599 77.5644C400.325 77.5644 400.913 76.9843 400.913 76.2686C400.913 75.553 400.325 74.9729 399.599 74.9729C398.874 74.9729 398.286 75.553 398.286 76.2686C398.286 76.9843 398.874 77.5644 399.599 77.5644Z"
              fill="#333333"
            />
            <path
              d="M411.48 77.5644C412.206 77.5644 412.794 76.9843 412.794 76.2686C412.794 75.553 412.206 74.9729 411.48 74.9729C410.755 74.9729 410.167 75.553 410.167 76.2686C410.167 76.9843 410.755 77.5644 411.48 77.5644Z"
              fill="#333333"
            />
            <path
              d="M377.147 87.5338C377.147 88.2505 376.56 88.8296 375.834 88.8296C375.107 88.8296 374.524 88.2505 374.524 87.5338C374.524 86.8171 375.111 86.238 375.838 86.238C376.564 86.238 377.151 86.8171 377.151 87.5338H377.147Z"
              fill="#333333"
            />
            <path
              d="M389.028 87.5338C389.028 88.2505 388.441 88.8296 387.715 88.8296C386.988 88.8296 386.401 88.2505 386.401 87.5338C386.401 86.8171 386.988 86.238 387.715 86.238C388.441 86.238 389.028 86.8171 389.028 87.5338Z"
              fill="#333333"
            />
            <path
              d="M400.913 87.5338C400.913 88.2505 400.326 88.8296 399.599 88.8296C398.873 88.8296 398.286 88.2505 398.286 87.5338C398.286 86.8171 398.873 86.238 399.599 86.238C400.326 86.238 400.913 86.8171 400.913 87.5338Z"
              fill="#333333"
            />
            <path
              d="M412.794 87.5338C412.794 88.2505 412.207 88.8296 411.48 88.8296C410.754 88.8296 410.167 88.2505 410.167 87.5338C410.167 86.8171 410.754 86.238 411.48 86.238C412.207 86.238 412.794 86.8171 412.794 87.5338Z"
              fill="#333333"
            />
            <path
              d="M377.147 98.803C377.147 99.5197 376.56 100.099 375.834 100.099C375.107 100.099 374.524 99.5157 374.524 98.803C374.524 98.0903 375.111 97.5072 375.838 97.5072C376.564 97.5072 377.151 98.0863 377.151 98.803H377.147Z"
              fill="#333333"
            />
            <path
              d="M389.028 98.803C389.028 99.5197 388.441 100.099 387.715 100.099C386.992 100.099 386.401 99.5197 386.401 98.803C386.401 98.0863 386.988 97.5072 387.715 97.5072C388.441 97.5072 389.028 98.0863 389.028 98.803Z"
              fill="#333333"
            />
            <path
              d="M400.913 98.803C400.913 99.5197 400.326 100.099 399.599 100.099C398.873 100.099 398.286 99.5197 398.286 98.803C398.286 98.0863 398.873 97.5072 399.599 97.5072C400.326 97.5072 400.913 98.0863 400.913 98.803Z"
              fill="#333333"
            />
            <path
              d="M412.794 98.803C412.794 99.5197 412.207 100.099 411.48 100.099C410.754 100.099 410.167 99.5197 410.167 98.803C410.167 98.0863 410.754 97.5072 411.48 97.5072C412.207 97.5072 412.794 98.0863 412.794 98.803Z"
              fill="#333333"
            />
            <path
              d="M377.146 110.068C377.146 110.785 376.559 111.364 375.833 111.364C375.106 111.364 374.52 110.785 374.52 110.068C374.52 109.351 375.106 108.772 375.833 108.772C376.559 108.772 377.146 109.351 377.146 110.068Z"
              fill="#333333"
            />
            <path
              d="M387.718 111.364C388.443 111.364 389.031 110.784 389.031 110.068C389.031 109.353 388.443 108.772 387.718 108.772C386.992 108.772 386.404 109.353 386.404 110.068C386.404 110.784 386.992 111.364 387.718 111.364Z"
              fill="#333333"
            />
            <path
              d="M399.598 111.364C400.324 111.364 400.912 110.784 400.912 110.068C400.912 109.353 400.324 108.772 399.598 108.772C398.873 108.772 398.285 109.353 398.285 110.068C398.285 110.784 398.873 111.364 399.598 111.364Z"
              fill="#333333"
            />
            <path
              d="M411.479 111.364C412.205 111.364 412.793 110.784 412.793 110.068C412.793 109.353 412.205 108.772 411.479 108.772C410.754 108.772 410.166 109.353 410.166 110.068C410.166 110.784 410.754 111.364 411.479 111.364Z"
              fill="#333333"
            />
          </g>
          <g clip-path="url(#clip1_3062_9265)">
            <path
              d="M119.282 51.8317L108.729 44.2933V59.3754L119.282 51.8317Z"
              fill="#F7DE51"
            />
            <path
              d="M106.311 51.8317L95.7578 44.2933V59.3754L106.311 51.8317Z"
              fill="#F7DE51"
            />
            <path
              d="M93.3391 51.8317L82.7861 44.2933V59.3754L93.3391 51.8317Z"
              fill="#F7DE51"
            />
            <path
              d="M80.3674 51.8317L69.8145 44.2933V59.3754L80.3674 51.8317Z"
              fill="#F7DE51"
            />
            <path
              d="M120.63 49.378L110.077 41.8395V56.9164L120.63 49.378Z"
              stroke="#333333"
              stroke-width="0.722063"
              stroke-miterlimit="10"
            />
            <path
              d="M107.658 49.378L97.1055 41.8395V56.9164L107.658 49.378Z"
              stroke="#333333"
              stroke-width="0.722063"
              stroke-miterlimit="10"
            />
            <path
              d="M94.6868 49.378L84.1338 41.8395V56.9164L94.6868 49.378Z"
              stroke="#333333"
              stroke-width="0.722063"
              stroke-miterlimit="10"
            />
            <path
              d="M81.7151 49.378L71.1621 41.8395V56.9164L81.7151 49.378Z"
              stroke="#333333"
              stroke-width="0.722063"
              stroke-miterlimit="10"
            />
          </g>
          <g clip-path="url(#clip2_3062_9265)">
            <path
              d="M58.7975 97.3052C59.6975 97.3052 60.427 96.573 60.427 95.6698C60.427 94.7666 59.6975 94.0344 58.7975 94.0344C57.8975 94.0344 57.168 94.7666 57.168 95.6698C57.168 96.573 57.8975 97.3052 58.7975 97.3052Z"
              fill="#B6C7DD"
            />
            <path
              d="M58.7975 112.1C59.6975 112.1 60.427 111.368 60.427 110.465C60.427 109.562 59.6975 108.83 58.7975 108.83C57.8975 108.83 57.168 109.562 57.168 110.465C57.168 111.368 57.8975 112.1 58.7975 112.1Z"
              fill="#B6C7DD"
            />
            <path
              d="M58.7975 126.895C59.6975 126.895 60.427 126.163 60.427 125.26C60.427 124.357 59.6975 123.625 58.7975 123.625C57.8975 123.625 57.168 124.357 57.168 125.26C57.168 126.163 57.8975 126.895 58.7975 126.895Z"
              fill="#B6C7DD"
            />
            <path
              d="M58.7975 141.691C59.6975 141.691 60.427 140.958 60.427 140.055C60.427 139.152 59.6975 138.42 58.7975 138.42C57.8975 138.42 57.168 139.152 57.168 140.055C57.168 140.958 57.8975 141.691 58.7975 141.691Z"
              fill="#B6C7DD"
            />
            <path
              d="M44.6305 97.3052C45.5305 97.3052 46.26 96.573 46.26 95.6698C46.26 94.7666 45.5305 94.0344 44.6305 94.0344C43.7305 94.0344 43.001 94.7666 43.001 95.6698C43.001 96.573 43.7305 97.3052 44.6305 97.3052Z"
              fill="#B6C7DD"
            />
            <path
              d="M44.6305 112.1C45.5305 112.1 46.26 111.368 46.26 110.465C46.26 109.562 45.5305 108.83 44.6305 108.83C43.7305 108.83 43.001 109.562 43.001 110.465C43.001 111.368 43.7305 112.1 44.6305 112.1Z"
              fill="#B6C7DD"
            />
            <path
              d="M44.6305 126.895C45.5305 126.895 46.26 126.163 46.26 125.26C46.26 124.357 45.5305 123.625 44.6305 123.625C43.7305 123.625 43.001 124.357 43.001 125.26C43.001 126.163 43.7305 126.895 44.6305 126.895Z"
              fill="#B6C7DD"
            />
            <path
              d="M44.6305 141.691C45.5305 141.691 46.26 140.958 46.26 140.055C46.26 139.152 45.5305 138.42 44.6305 138.42C43.7305 138.42 43.001 139.152 43.001 140.055C43.001 140.958 43.7305 141.691 44.6305 141.691Z"
              fill="#B6C7DD"
            />
            <path
              d="M30.4586 97.3C29.5573 97.3 28.8291 96.5692 28.8291 95.6647C28.8291 94.7601 29.5573 94.0293 30.4586 94.0293C31.36 94.0293 32.0882 94.7601 32.0882 95.6647C32.0882 96.5692 31.36 97.3 30.4586 97.3Z"
              fill="#B6C7DD"
            />
            <path
              d="M30.4586 112.095C29.5573 112.095 28.8291 111.364 28.8291 110.46C28.8291 109.555 29.5573 108.824 30.4586 108.824C31.36 108.824 32.0882 109.555 32.0882 110.46C32.0882 111.364 31.36 112.095 30.4586 112.095Z"
              fill="#B6C7DD"
            />
            <path
              d="M30.4586 126.895C29.5573 126.895 28.8291 126.165 28.8291 125.26C28.8291 124.355 29.5573 123.625 30.4586 123.625C31.36 123.625 32.0882 124.355 32.0882 125.26C32.0882 126.165 31.36 126.895 30.4586 126.895Z"
              fill="#B6C7DD"
            />
            <path
              d="M30.4586 141.691C29.5573 141.691 28.8291 140.96 28.8291 140.055C28.8291 139.151 29.5573 138.42 30.4586 138.42C31.36 138.42 32.0882 139.151 32.0882 140.055C32.0882 140.96 31.36 141.691 30.4586 141.691Z"
              fill="#B6C7DD"
            />
            <path
              d="M16.2916 97.3C15.3903 97.3 14.6621 96.5692 14.6621 95.6647C14.6621 94.7601 15.3903 94.0293 16.2916 94.0293C17.193 94.0293 17.9212 94.7601 17.9212 95.6647C17.9212 96.5692 17.193 97.3 16.2916 97.3Z"
              fill="#B6C7DD"
            />
            <path
              d="M16.2916 112.095C15.3903 112.095 14.6621 111.364 14.6621 110.46C14.6621 109.555 15.3903 108.824 16.2916 108.824C17.193 108.824 17.9212 109.555 17.9212 110.46C17.9212 111.364 17.193 112.095 16.2916 112.095Z"
              fill="#B6C7DD"
            />
            <path
              d="M16.2916 126.895C15.3903 126.895 14.6621 126.165 14.6621 125.26C14.6621 124.355 15.3903 123.625 16.2916 123.625C17.193 123.625 17.9212 124.355 17.9212 125.26C17.9212 126.165 17.193 126.895 16.2916 126.895Z"
              fill="#B6C7DD"
            />
            <path
              d="M16.2916 141.691C15.3903 141.691 14.6621 140.96 14.6621 140.055C14.6621 139.151 15.3903 138.42 16.2916 138.42C17.193 138.42 17.9212 139.151 17.9212 140.055C17.9212 140.96 17.193 141.691 16.2916 141.691Z"
              fill="#B6C7DD"
            />
            <path
              d="M2.12465 97.3C1.22332 97.3 0.495117 96.5692 0.495117 95.6646C0.495117 94.7601 1.22332 94.0344 2.12465 94.0344C3.02599 94.0344 3.75419 94.7652 3.75419 95.6697C3.75419 96.5743 3.02599 97.3051 2.12465 97.3051V97.3Z"
              fill="#B6C7DD"
            />
            <path
              d="M2.12465 112.095C1.22332 112.095 0.495117 111.364 0.495117 110.46C0.495117 109.555 1.22332 108.824 2.12465 108.824C3.02599 108.824 3.75419 109.555 3.75419 110.46C3.75419 111.364 3.02599 112.095 2.12465 112.095Z"
              fill="#B6C7DD"
            />
            <path
              d="M2.12465 126.895C1.22332 126.895 0.495117 126.165 0.495117 125.26C0.495117 124.355 1.22332 123.625 2.12465 123.625C3.02599 123.625 3.75419 124.355 3.75419 125.26C3.75419 126.165 3.02599 126.895 2.12465 126.895Z"
              fill="#B6C7DD"
            />
            <path
              d="M2.12465 141.691C1.22332 141.691 0.495117 140.96 0.495117 140.055C0.495117 139.151 1.22332 138.42 2.12465 138.42C3.02599 138.42 3.75419 139.151 3.75419 140.055C3.75419 140.96 3.02599 141.691 2.12465 141.691Z"
              fill="#B6C7DD"
            />
          </g>
          <defs>
            <clipPath id="clip0_3062_9265">
              <rect
                width="38.2693"
                height="47.6562"
                fill="white"
                transform="translate(374.524 63.7077)"
              />
            </clipPath>
            <clipPath id="clip1_3062_9265">
              <rect
                width="51.2665"
                height="18.0516"
                fill="white"
                transform="translate(69.8135 41.3238)"
              />
            </clipPath>
            <clipPath id="clip2_3062_9265">
              <rect
                width="59.9312"
                height="47.6562"
                fill="white"
                transform="translate(0.496094 94.0344)"
              />
            </clipPath>
          </defs>
        </svg>

        <h4 className="mt-2 flex justify-center bg-yellow-300 p-4 text-lg font-bold">
          Payment Reminder
        </h4>
      </div>
      <div className="p-6 ">
        <p className="text-md font-medium">{data?.title}</p>
      </div>
      <div className="flex items-center justify-between p-2">
        <div className="flex items-center gap-2">
          <svg
            width="45"
            height="45"
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="22.5"
              cy="22.5"
              r="22.5"
              fill="#FFC727"
              fill-opacity="0.2"
            />
            <path
              d="M28.125 22.9693C28.125 23.8964 27.8501 24.8027 27.335 25.5735C26.8199 26.3444 26.0879 26.9452 25.2313 27.3C24.3748 27.6548 23.4323 27.7476 22.523 27.5667C21.6137 27.3859 20.7785 26.9394 20.1229 26.2839C19.4674 25.6283 19.0209 24.7931 18.8401 23.8838C18.6592 22.9745 18.752 22.032 19.1068 21.1755C19.4616 20.3189 20.0624 19.5869 20.8333 19.0718C21.6041 18.5567 22.5104 18.2818 23.4375 18.2818C24.6807 18.2818 25.873 18.7757 26.7521 19.6547C27.6311 20.5338 28.125 21.7261 28.125 22.9693ZM37.5 15.4693V30.4693C37.5 30.7179 37.4012 30.9564 37.2254 31.1322C37.0496 31.308 36.8111 31.4068 36.5625 31.4068H10.3125C10.0639 31.4068 9.8254 31.308 9.64959 31.1322C9.47377 30.9564 9.375 30.7179 9.375 30.4693V15.4693C9.375 15.2207 9.47377 14.9822 9.64959 14.8064C9.8254 14.6306 10.0639 14.5318 10.3125 14.5318H36.5625C36.8111 14.5318 37.0496 14.6306 37.2254 14.8064C37.4012 14.9822 37.5 15.2207 37.5 15.4693ZM35.625 20.9009C34.5605 20.5862 33.5916 20.0101 32.8067 19.2251C32.0217 18.4402 31.4456 17.4713 31.1309 16.4068H15.7441C15.4294 17.4713 14.8533 18.4402 14.0683 19.2251C13.2834 20.0101 12.3145 20.5862 11.25 20.9009V25.0377C12.3145 25.3524 13.2834 25.9285 14.0683 26.7135C14.8533 27.4984 15.4294 28.4673 15.7441 29.5318H31.1309C31.4456 28.4673 32.0217 27.4984 32.8067 26.7135C33.5916 25.9285 34.5605 25.3524 35.625 25.0377V20.9009Z"
              fill="#FFC727"
            />
          </svg>
          <div className="flex flex-col items-center">
            <p className="font-bold">{data?.dueAmount}</p>
            <p className="text-sm font-bold text-gray-600">Total Amount Due</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <svg
            width="45"
            height="45"
            viewBox="0 0 34 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="17.0169"
              cy="16.4699"
              r="16.2464"
              fill="#FFC727"
              fill-opacity="0.2"
            />
            <path
              d="M22.9402 9.36164H21.1632V8.76932C21.1632 8.61223 21.1008 8.46157 20.9897 8.35049C20.8786 8.23941 20.728 8.177 20.5709 8.177C20.4138 8.177 20.2631 8.23941 20.1521 8.35049C20.041 8.46157 19.9786 8.61223 19.9786 8.76932V9.36164H14.0554V8.76932C14.0554 8.61223 13.993 8.46157 13.8819 8.35049C13.7708 8.23941 13.6202 8.177 13.4631 8.177C13.306 8.177 13.1553 8.23941 13.0443 8.35049C12.9332 8.46157 12.8708 8.61223 12.8708 8.76932V9.36164H11.0938C10.7796 9.36164 10.4783 9.48645 10.2562 9.70861C10.034 9.93077 9.90918 10.2321 9.90918 10.5463V22.3926C9.90918 22.7068 10.034 23.0081 10.2562 23.2303C10.4783 23.4524 10.7796 23.5773 11.0938 23.5773H22.9402C23.2543 23.5773 23.5557 23.4524 23.7778 23.2303C24 23.0081 24.1248 22.7068 24.1248 22.3926V10.5463C24.1248 10.2321 24 9.93077 23.7778 9.70861C23.5557 9.48645 23.2543 9.36164 22.9402 9.36164ZM13.7592 20.6157C13.5835 20.6157 13.4117 20.5636 13.2656 20.4659C13.1195 20.3683 13.0056 20.2295 12.9384 20.0672C12.8712 19.9048 12.8536 19.7262 12.8878 19.5539C12.9221 19.3815 13.0067 19.2232 13.131 19.0989C13.2553 18.9747 13.4136 18.8901 13.5859 18.8558C13.7583 18.8215 13.9369 18.8391 14.0992 18.9063C14.2616 18.9736 14.4004 19.0875 14.498 19.2336C14.5956 19.3797 14.6477 19.5515 14.6477 19.7272C14.6477 19.9628 14.5541 20.1888 14.3875 20.3554C14.2209 20.5221 13.9949 20.6157 13.7592 20.6157ZM17.017 20.6157C16.8413 20.6157 16.6695 20.5636 16.5234 20.4659C16.3773 20.3683 16.2634 20.2295 16.1961 20.0672C16.1289 19.9048 16.1113 19.7262 16.1456 19.5539C16.1799 19.3815 16.2645 19.2232 16.3887 19.0989C16.513 18.9747 16.6713 18.8901 16.8437 18.8558C17.016 18.8215 17.1946 18.8391 17.357 18.9063C17.5193 18.9736 17.6581 19.0875 17.7557 19.2336C17.8534 19.3797 17.9055 19.5515 17.9055 19.7272C17.9055 19.9628 17.8119 20.1888 17.6452 20.3554C17.4786 20.5221 17.2526 20.6157 17.017 20.6157ZM17.017 17.6541C16.8413 17.6541 16.6695 17.602 16.5234 17.5043C16.3773 17.4067 16.2634 17.268 16.1961 17.1056C16.1289 16.9433 16.1113 16.7646 16.1456 16.5923C16.1799 16.4199 16.2645 16.2616 16.3887 16.1374C16.513 16.0131 16.6713 15.9285 16.8437 15.8942C17.016 15.8599 17.1946 15.8775 17.357 15.9448C17.5193 16.012 17.6581 16.1259 17.7557 16.272C17.8534 16.4181 17.9055 16.5899 17.9055 16.7656C17.9055 17.0012 17.8119 17.2272 17.6452 17.3939C17.4786 17.5605 17.2526 17.6541 17.017 17.6541ZM20.2747 20.6157C20.099 20.6157 19.9272 20.5636 19.7811 20.4659C19.635 20.3683 19.5211 20.2295 19.4539 20.0672C19.3866 19.9048 19.369 19.7262 19.4033 19.5539C19.4376 19.3815 19.5222 19.2232 19.6465 19.0989C19.7707 18.9747 19.9291 18.8901 20.1014 18.8558C20.2737 18.8215 20.4524 18.8391 20.6147 18.9063C20.7771 18.9736 20.9158 19.0875 21.0135 19.2336C21.1111 19.3797 21.1632 19.5515 21.1632 19.7272C21.1632 19.9628 21.0696 20.1888 20.903 20.3554C20.7364 20.5221 20.5104 20.6157 20.2747 20.6157ZM20.2747 17.6541C20.099 17.6541 19.9272 17.602 19.7811 17.5043C19.635 17.4067 19.5211 17.268 19.4539 17.1056C19.3866 16.9433 19.369 16.7646 19.4033 16.5923C19.4376 16.4199 19.5222 16.2616 19.6465 16.1374C19.7707 16.0131 19.9291 15.9285 20.1014 15.8942C20.2737 15.8599 20.4524 15.8775 20.6147 15.9448C20.7771 16.012 20.9158 16.1259 21.0135 16.272C21.1111 16.4181 21.1632 16.5899 21.1632 16.7656C21.1632 17.0012 21.0696 17.2272 20.903 17.3939C20.7364 17.5605 20.5104 17.6541 20.2747 17.6541ZM22.9402 12.9155H11.0938V10.5463H12.8708V11.1386C12.8708 11.2957 12.9332 11.4463 13.0443 11.5574C13.1553 11.6685 13.306 11.7309 13.4631 11.7309C13.6202 11.7309 13.7708 11.6685 13.8819 11.5574C13.993 11.4463 14.0554 11.2957 14.0554 11.1386V10.5463H19.9786V11.1386C19.9786 11.2957 20.041 11.4463 20.1521 11.5574C20.2631 11.6685 20.4138 11.7309 20.5709 11.7309C20.728 11.7309 20.8786 11.6685 20.9897 11.5574C21.1008 11.4463 21.1632 11.2957 21.1632 11.1386V10.5463H22.9402V12.9155Z"
              fill="#FFC727"
            />
          </svg>
          <div className="flex flex-col items-center">
            <p className="font-bold">{formatDateCommon(data?.dueDate)}</p>
            <p className="text-sm font-bold text-gray-600">Due Date</p>
          </div>
        </div>
      </div>
    </>
  );
};
